export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: any; output: any };
  Decimal: { input: any; output: any };
  JSON: { input: any; output: any };
  UUID: { input: any; output: any };
};

export type Action =
  | DiscordMessageAction
  | EmailAction
  | SlackMessageAction
  | WebhookAction;

export type ActionNode = {
  __typename?: 'ActionNode';
  action: Action;
  /** Get control flow slots (execution flow connections) */
  controlFlows: Array<WorkflowNodeSlot>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  inputs: Array<WorkflowNodeSlot>;
  label?: Maybe<Scalars['String']['output']>;
  outputs: Array<WorkflowNodeSlot>;
  position: Scalars['JSON']['output'];
  styleData: Scalars['JSON']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum ActionType {
  Contract = 'CONTRACT',
  Database = 'DATABASE',
  DiscordMessage = 'DISCORD_MESSAGE',
  Email = 'EMAIL',
  SlackMessage = 'SLACK_MESSAGE',
  Webhook = 'WEBHOOK',
}

export type Address = {
  __typename?: 'Address';
  /** The address string (e.g., 0x...) */
  address: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Optional entity associated with this address */
  entity?: Maybe<Entity>;
  /** Optional label for this address (e.g., "OFAC SDN Entity Wallet #1") */
  label?: Maybe<Scalars['String']['output']>;
  /** Lists that contain this address */
  lists: ListConnection;
  /** Risks associated with this address */
  risks: AddressRiskConnection;
};

export type AddressListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AddressRisksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<FilterInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortInput>;
};

export type AddressConnection = {
  __typename?: 'AddressConnection';
  edges: Array<AddressEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AddressEdge = {
  __typename?: 'AddressEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Address;
};

export type AddressRisk = {
  __typename?: 'AddressRisk';
  /** Address this risk belongs to */
  address: Address;
  /** When the risk was created */
  createdAt: Scalars['DateTime']['output'];
  /** Description of the risk */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the risk */
  id: Scalars['UUID']['output'];
  /** Additional metadata as JSON */
  metadata: Scalars['JSON']['output'];
  /** Type of risk (e.g., "OFAC_SDN", "HACKER_WALLET", "SCAM") */
  riskType: Scalars['String']['output'];
  /** Severity level (e.g., "high", "medium", "low") */
  severity: Scalars['String']['output'];
  /** Source of the risk information */
  source?: Maybe<Scalars['String']['output']>;
  /** When the risk was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

export type AddressRiskConnection = {
  __typename?: 'AddressRiskConnection';
  edges: Array<AddressRiskEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AddressRiskEdge = {
  __typename?: 'AddressRiskEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: AddressRisk;
};

export type Alert = {
  __typename?: 'Alert';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  destinations: Array<AlertDestination>;
  id: Scalars['UUID']['output'];
  lastTriggeredAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  owner?: Maybe<Owner>;
  signal?: Maybe<Signal>;
  status: AlertStatus;
  triggerCount: Scalars['Int']['output'];
  triggers: Array<AlertTrigger>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AlertTriggersArgs = {
  limit?: Scalars['Int']['input'];
};

export type AlertConnection = {
  __typename?: 'AlertConnection';
  edges: Array<AlertEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AlertDestination = {
  __typename?: 'AlertDestination';
  alert?: Maybe<Alert>;
  createdAt: Scalars['DateTime']['output'];
  destinationType: AlertDestinationType;
  /** The Discord channel ID (only set for Discord destinations) */
  discordChannelId?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  /** The Slack channel ID (only set for Slack destinations) */
  slackChannelId?: Maybe<Scalars['String']['output']>;
  /** The target integration (Discord bot, Webhook, or Slack bot) */
  target?: Maybe<AlertDestinationTarget>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Union representing the target integration for an alert destination */
export type AlertDestinationTarget = DiscordBot | SlackInstallation | Webhook;

export enum AlertDestinationType {
  Discord = 'DISCORD',
  Email = 'EMAIL',
  Slack = 'SLACK',
  Webhook = 'WEBHOOK',
}

/** An edge in a connection. */
export type AlertEdge = {
  __typename?: 'AlertEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Alert;
};

export enum AlertStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Paused = 'PAUSED',
}

export type AlertTrigger = {
  __typename?: 'AlertTrigger';
  alert?: Maybe<Alert>;
  blockNumber?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  transactionHash?: Maybe<Scalars['String']['output']>;
  triggeredAt: Scalars['DateTime']['output'];
  triggeredValue?: Maybe<Scalars['String']['output']>;
};

/** API Key metadata (no secrets exposed) */
export type ApiKey = {
  __typename?: 'ApiKey';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  keyType: ApiKeyType;
  label: Scalars['String']['output'];
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  teamId?: Maybe<Scalars['UUID']['output']>;
  userId?: Maybe<Scalars['UUID']['output']>;
};

export enum ApiKeyType {
  Team = 'TEAM',
  User = 'USER',
}

export type Block = {
  __typename?: 'Block';
  /** Average transaction value in native token (ETH for Ethereum, etc.) */
  averageValueNative?: Maybe<Scalars['Decimal']['output']>;
  /** Average transaction value in USD */
  averageValueUsd?: Maybe<Scalars['Decimal']['output']>;
  createdAt: Scalars['DateTime']['output'];
  hash: Scalars['String']['output'];
  /** Cached native token price in USD at block time (ETH for Ethereum, etc.) */
  nativeTokenPriceUsd?: Maybe<Scalars['Decimal']['output']>;
  number: Scalars['Int']['output'];
  /**
   * Risks for addresses involved in transactions within this block
   * Returns a paginated connection of address risks with filtering and sorting
   */
  risks: AddressRiskConnection;
  timestamp: Scalars['DateTime']['output'];
  transactionCount?: Maybe<Scalars['Int']['output']>;
  transactions: TransactionConnection;
  /** Total block value in native token (sum of all transaction values) */
  valueNative?: Maybe<Scalars['Decimal']['output']>;
  /** Total block value in USD (sum of all transaction values) */
  valueUsd?: Maybe<Scalars['Decimal']['output']>;
};

export type BlockRisksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<FilterInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortInput>;
};

export type BlockTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<FilterInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortInput>;
};

export type BlockConnection = {
  __typename?: 'BlockConnection';
  edges: Array<BlockEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BlockEdge = {
  __typename?: 'BlockEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Block;
};

export type BlockFingerprint = {
  __typename?: 'BlockFingerprint';
  field: Scalars['String']['output'];
  operation: ConditionOperator;
  value: FingerprintValue;
};

/** Input for testing a Block signal */
export type BlockTestInput = {
  /** The block hash to test against (0x-prefixed hex string, mutually exclusive with block_number) */
  blockHash?: InputMaybe<Scalars['String']['input']>;
  /** The block number to test against (mutually exclusive with block_hash) */
  blockNumber?: InputMaybe<Scalars['Int']['input']>;
};

export enum ConditionOperator {
  Between = 'BETWEEN',
  Contains = 'CONTAINS',
  EndsWith = 'ENDS_WITH',
  Equals = 'EQUALS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  /** Check if value exists in a list (requires list_id reference) */
  InList = 'IN_LIST',
  IsNotNull = 'IS_NOT_NULL',
  IsNull = 'IS_NULL',
  LessThan = 'LESS_THAN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
  NotBetween = 'NOT_BETWEEN',
  NotContains = 'NOT_CONTAINS',
  NotEquals = 'NOT_EQUALS',
  /** Check if value does NOT exist in a list (requires list_id reference) */
  NotInList = 'NOT_IN_LIST',
  StartsWith = 'STARTS_WITH',
}

export enum ConnectionStatus {
  /** Connection test succeeded */
  Connected = 'CONNECTED',
  /** Connection test failed */
  Error = 'ERROR',
  /** Connection has not been tested yet */
  NotTested = 'NOT_TESTED',
}

export type Contract = {
  __typename?: 'Contract';
  /** Contract ABI metadata (nullable for unverified contracts) */
  abi?: Maybe<ContractAbi>;
  /** Contract address (e.g., "0x...") */
  address: Address;
  /** Chain ID where this contract is deployed */
  chainId: Scalars['Int']['output'];
  /** Contract bytecode (hex-encoded) */
  code: Scalars['String']['output'];
  /** Timestamp when this contract record was created */
  createdAt: Scalars['DateTime']['output'];
  /** Address that deployed this contract */
  deployer: Address;
  /** Block number when this contract was deployed */
  deploymentBlock: Scalars['Int']['output'];
  /** Transaction hash that deployed this contract */
  deploymentTxHash: Scalars['String']['output'];
  /** Contract errors (from ABI, empty if unverified) */
  errors: Array<ContractError>;
  /** Contract events (from ABI, empty if unverified) */
  events: Array<ContractEvent>;
  /** Contract functions (from ABI, empty if unverified) */
  functions: Array<ContractFunction>;
  /** Optional contract name */
  name?: Maybe<Scalars['String']['output']>;
  /** Contract source code (nullable for contracts without uploaded source) */
  source?: Maybe<ContractSource>;
  /** Whether this contract has been verified (has source code that matches the ABI) */
  verified: Scalars['Boolean']['output'];
};

export type ContractAbi = {
  __typename?: 'ContractAbi';
  /** ABI JSON as string */
  abiJson: Scalars['String']['output'];
  /** Content hash (SHA256) of the ABI JSON for deduplication */
  contentHash: Scalars['String']['output'];
  /** Timestamp when this ABI was created */
  createdAt: Scalars['DateTime']['output'];
  /** Contract errors defined in this ABI */
  errors: Array<ContractError>;
  /** Contract events defined in this ABI */
  events: Array<ContractEvent>;
  /** Contract functions defined in this ABI */
  functions: Array<ContractFunction>;
  /** ABI ID */
  id: Scalars['UUID']['output'];
  /** Optional ABI name */
  name?: Maybe<Scalars['String']['output']>;
  /** Timestamp when this ABI was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ContractConnection = {
  __typename?: 'ContractConnection';
  edges: Array<ContractEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ContractEdge = {
  __typename?: 'ContractEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Contract;
};

/** GraphQL type for Contract Error */
export type ContractError = {
  __typename?: 'ContractError';
  id: Scalars['UUID']['output'];
  inputs: Scalars['String']['output'];
  name: Scalars['String']['output'];
  selector: Scalars['String']['output'];
  signature: Scalars['String']['output'];
};

/** GraphQL type for Contract Event */
export type ContractEvent = {
  __typename?: 'ContractEvent';
  anonymous: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  inputs: Scalars['String']['output'];
  name: Scalars['String']['output'];
  signature: Scalars['String']['output'];
  topicHash: Scalars['String']['output'];
};

/** GraphQL type for Contract Function */
export type ContractFunction = {
  __typename?: 'ContractFunction';
  id: Scalars['UUID']['output'];
  inputs: Scalars['String']['output'];
  name: Scalars['String']['output'];
  outputs: Scalars['String']['output'];
  selector: Scalars['String']['output'];
  signature: Scalars['String']['output'];
  stateMutability: Scalars['String']['output'];
};

export type ContractSource = {
  __typename?: 'ContractSource';
  /** ABI ID extracted from this source code */
  abiId: Scalars['String']['output'];
  /** Chain ID where this contract is deployed */
  chainId: Scalars['Int']['output'];
  /** Compiler version used (e.g., "0.8.20") */
  compilerVersion: Scalars['String']['output'];
  /** ABI-encoded constructor arguments */
  constructorArguments?: Maybe<Scalars['String']['output']>;
  /** Contract address this source belongs to */
  contractAddress: Scalars['String']['output'];
  /** Name of the main contract in the source file */
  contractName?: Maybe<Scalars['String']['output']>;
  /** Timestamp when this record was created */
  createdAt: Scalars['DateTime']['output'];
  /** EVM version used for compilation (e.g., "paris", "shanghai") */
  evmVersion?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this source record */
  id: Scalars['String']['output'];
  /** Whether optimization was enabled during compilation */
  optimizationEnabled: Scalars['Boolean']['output'];
  /** Number of optimization runs (if optimization was enabled) */
  optimizationRuns?: Maybe<Scalars['Int']['output']>;
  /** The Solidity source code */
  sourceCode: Scalars['String']['output'];
  /** SHA256 hash of the source code (for deduplication) */
  sourceHash: Scalars['String']['output'];
  /** Timestamp when this record was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the source has been verified (computed from verified_at) */
  verified: Scalars['Boolean']['output'];
  /** Timestamp when the source was verified (NULL if not verified) */
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Input for creating an alert destination inline with the alert */
export type CreateAlertDestinationInput = {
  destinationType: AlertDestinationType;
  /** Required for Discord destinations */
  discordBotId?: InputMaybe<Scalars['UUID']['input']>;
  /** Optional channel ID for Discord destinations */
  discordChannelId?: InputMaybe<Scalars['String']['input']>;
  /** Optional channel ID for Slack destinations */
  slackChannelId?: InputMaybe<Scalars['String']['input']>;
  /** Required for Slack destinations */
  slackInstallationId?: InputMaybe<Scalars['UUID']['input']>;
  /** Required for Webhook destinations */
  webhookId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreateAlertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** Required destinations to create with the alert (at least one must be provided) */
  destinations: Array<CreateAlertDestinationInput>;
  name: Scalars['String']['input'];
  ownerTeamId?: InputMaybe<Scalars['UUID']['input']>;
  ownerUserId?: InputMaybe<Scalars['UUID']['input']>;
  signalId: Scalars['UUID']['input'];
};

/** Input for creating a new API key */
export type CreateApiKeyInput = {
  /** Type of API key: USER or TEAM */
  keyType: ApiKeyType;
  /** Label for the API key */
  label: Scalars['String']['input'];
  /** Team ID (required if keyType is TEAM) */
  teamId?: InputMaybe<Scalars['UUID']['input']>;
};

/** Response from creating an API key */
export type CreateApiKeyPayload = {
  __typename?: 'CreateApiKeyPayload';
  /** API key metadata */
  apiKey: ApiKey;
  /** The created API key ID */
  keyId: Scalars['UUID']['output'];
  /** The plaintext API key - shown only once! */
  plaintextKey: Scalars['String']['output'];
};

export type CreateDiscordBotChannelInput = {
  botId: Scalars['UUID']['input'];
  channelType: DiscordChannelTypeEnum;
  discordChannelId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDiscordBotInput = {
  applicationId: Scalars['String']['input'];
  botToken: Scalars['String']['input'];
  botUserId?: InputMaybe<Scalars['String']['input']>;
  botUsername?: InputMaybe<Scalars['String']['input']>;
  discordGuildId?: InputMaybe<Scalars['String']['input']>;
  guildName?: InputMaybe<Scalars['String']['input']>;
  ownerTeamId?: InputMaybe<Scalars['UUID']['input']>;
  ownerUserId?: InputMaybe<Scalars['UUID']['input']>;
  publicKey: Scalars['String']['input'];
};

export type CreateDiscordMessageInput = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  botId?: InputMaybe<Scalars['UUID']['input']>;
  channelId?: InputMaybe<Scalars['UUID']['input']>;
  content: Scalars['String']['input'];
  embeds?: InputMaybe<Scalars['JSON']['input']>;
  messageType: DiscordMessageType;
  tts?: InputMaybe<Scalars['Boolean']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  webhookId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreateDiscordServerInput = {
  name: Scalars['String']['input'];
  ownerTeamId?: InputMaybe<Scalars['UUID']['input']>;
  ownerUserId?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input for creating a new entity */
export type CreateEntityInput = {
  /** Geographic location (optional) */
  location?: InputMaybe<Scalars['String']['input']>;
  /** Name of the entity */
  name: Scalars['String']['input'];
};

export type CreateListInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  ownerTeamId?: InputMaybe<Scalars['UUID']['input']>;
  ownerUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreateListItemInput = {
  listId: Scalars['UUID']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  value: Scalars['String']['input'];
};

export type CreateSignalInput = {
  description: Scalars['String']['input'];
  fingerprints?: InputMaybe<Array<TransactionFingerprintInput>>;
  name: Scalars['String']['input'];
  signalType: SignalType;
};

export type CreateSlackMessageInput = {
  channelId: Scalars['UUID']['input'];
  installationId: Scalars['UUID']['input'];
  text: Scalars['String']['input'];
};

export type CreateTeamInput = {
  name: Scalars['String']['input'];
};

export type CreateUserInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};

export type CreateWebhookInput = {
  headers?: InputMaybe<Scalars['JSON']['input']>;
  label: Scalars['String']['input'];
  method: Scalars['String']['input'];
  ownerTeamId?: InputMaybe<Scalars['UUID']['input']>;
  ownerUserId?: InputMaybe<Scalars['UUID']['input']>;
  type: WebhookType;
  url: Scalars['String']['input'];
};

export type CreateWorkflowEdgeInput = {
  edgeType?: InputMaybe<Scalars['String']['input']>;
  sourceHandle?: InputMaybe<Scalars['String']['input']>;
  sourceNodeId: Scalars['UUID']['input'];
  targetHandle?: InputMaybe<Scalars['String']['input']>;
  targetNodeId: Scalars['UUID']['input'];
  workflowId: Scalars['UUID']['input'];
};

export type CreateWorkflowInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  viewportState: ViewportStateInput;
};

export type CreateWorkflowNodeInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['UUID']['input'];
  nodeType: WorkflowNodeType;
  position: Scalars['JSON']['input'];
  styleData: Scalars['JSON']['input'];
  workflowId: Scalars['UUID']['input'];
};

export type CreateWorkflowNodeSlotInput = {
  dataType?: InputMaybe<SlotDataType>;
  direction: SlotDirection;
  key: Scalars['String']['input'];
  nodeId: Scalars['UUID']['input'];
  optional: Scalars['Boolean']['input'];
  slotType: SlotType;
};

export type DecodedEvent = {
  __typename?: 'DecodedEvent';
  /** ABI ID used to decode this event */
  abiId: Scalars['UUID']['output'];
  /** Contract event ID from the ABI */
  contractEventId: Scalars['UUID']['output'];
  /** Timestamp when this event was decoded */
  createdAt: Scalars['DateTime']['output'];
  /** Decoded event data as JSON */
  decodedData: Scalars['JSON']['output'];
  /** Name of the decoded event (e.g., "Transfer") */
  eventName: Scalars['String']['output'];
  /** Full event signature (e.g., "Transfer(address,address,uint256)") */
  eventSignature: Scalars['String']['output'];
  /** Unique ID of the decoded event */
  id: Scalars['UUID']['output'];
  /** The original log record this event was decoded from */
  log?: Maybe<Log>;
  /** ID of the log this event was decoded from */
  logId: Scalars['UUID']['output'];
};

export type DecodedEventConnection = {
  __typename?: 'DecodedEventConnection';
  edges: Array<DecodedEventEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DecodedEventEdge = {
  __typename?: 'DecodedEventEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DecodedEvent;
};

export type DelayNode = {
  __typename?: 'DelayNode';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  inputs: Array<WorkflowNodeSlot>;
  label?: Maybe<Scalars['String']['output']>;
  outputs: Array<WorkflowNodeSlot>;
  position: Scalars['JSON']['output'];
  styleData: Scalars['JSON']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DeleteListItemInput = {
  listId: Scalars['UUID']['input'];
  value: Scalars['String']['input'];
};

export type DiscordBot = {
  __typename?: 'DiscordBot';
  applicationId: Scalars['String']['output'];
  botUserId?: Maybe<Scalars['String']['output']>;
  botUsername?: Maybe<Scalars['String']['output']>;
  channels: Array<DiscordBotChannel>;
  createdAt: Scalars['DateTime']['output'];
  discordGuildId?: Maybe<Scalars['String']['output']>;
  guildName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  owner?: Maybe<Owner>;
  publicKey: Scalars['String']['output'];
  tokenLastRotatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type DiscordBotChannel = {
  __typename?: 'DiscordBotChannel';
  bot?: Maybe<DiscordBot>;
  channelType: DiscordChannelTypeEnum;
  createdAt: Scalars['DateTime']['output'];
  discordChannelId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isArchived: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type DiscordChannel = {
  __typename?: 'DiscordChannel';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  server: DiscordServer;
};

export type DiscordChannelConnection = {
  __typename?: 'DiscordChannelConnection';
  edges: Array<DiscordChannelEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DiscordChannelEdge = {
  __typename?: 'DiscordChannelEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DiscordChannel;
};

export enum DiscordChannelTypeEnum {
  Dm = 'DM',
  GroupDm = 'GROUP_DM',
  GuildCategory = 'GUILD_CATEGORY',
  GuildForum = 'GUILD_FORUM',
  GuildNews = 'GUILD_NEWS',
  GuildStageVoice = 'GUILD_STAGE_VOICE',
  GuildText = 'GUILD_TEXT',
  GuildVoice = 'GUILD_VOICE',
}

export type DiscordMessage = {
  __typename?: 'DiscordMessage';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  bot?: Maybe<DiscordBot>;
  botChannel?: Maybe<DiscordBotChannel>;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  embeds?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['UUID']['output'];
  messageType: DiscordMessageType;
  tts: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  username?: Maybe<Scalars['String']['output']>;
  webhook?: Maybe<Webhook>;
};

export type DiscordMessageAction = {
  __typename?: 'DiscordMessageAction';
  actionType: ActionType;
  createdAt: Scalars['DateTime']['output'];
  discordMessage: DiscordMessage;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum DiscordMessageType {
  Bot = 'BOT',
  Webhook = 'WEBHOOK',
}

export type DiscordServer = {
  __typename?: 'DiscordServer';
  channels: DiscordChannelConnection;
  connectionStatus: ConnectionStatus;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  owner?: Maybe<Owner>;
};

export type DiscordServerChannelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type DiscordServerConnection = {
  __typename?: 'DiscordServerConnection';
  edges: Array<DiscordServerEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DiscordServerEdge = {
  __typename?: 'DiscordServerEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DiscordServer;
};

export type EmailAction = {
  __typename?: 'EmailAction';
  actionType: ActionType;
  createdAt: Scalars['DateTime']['output'];
  emailAction?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type EnricherNode = {
  __typename?: 'EnricherNode';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  inputs: Array<WorkflowNodeSlot>;
  label?: Maybe<Scalars['String']['output']>;
  outputs: Array<WorkflowNodeSlot>;
  position: Scalars['JSON']['output'];
  styleData: Scalars['JSON']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Entity = {
  __typename?: 'Entity';
  /** Addresses associated with this entity */
  addresses: AddressConnection;
  /** Timestamp when the entity was created */
  createdAt: Scalars['String']['output'];
  /** Unique identifier for the entity */
  id: Scalars['UUID']['output'];
  /** Geographic location of the entity (e.g., country, city) extracted from OFAC SDN data */
  location?: Maybe<Scalars['String']['output']>;
  /** Name of the entity */
  name: Scalars['String']['output'];
  /** Risks associated with this entity */
  risks: EntityRiskConnection;
};

export type EntityAddressesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type EntityRisksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<FilterInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortInput>;
};

export type EntityConnection = {
  __typename?: 'EntityConnection';
  edges: Array<EntityEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EntityEdge = {
  __typename?: 'EntityEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Entity;
};

export type EntityRisk = {
  __typename?: 'EntityRisk';
  /** When the risk was created */
  createdAt: Scalars['DateTime']['output'];
  /** Description of the risk */
  description?: Maybe<Scalars['String']['output']>;
  /** Entity this risk belongs to */
  entityId: Scalars['UUID']['output'];
  /** Unique identifier for the risk */
  id: Scalars['UUID']['output'];
  /** Additional metadata as JSON */
  metadata: Scalars['JSON']['output'];
  /** Type of risk (e.g., "OFAC_SDN", "HACKER_GROUP", "SCAM") */
  riskType: Scalars['String']['output'];
  /** Severity level (e.g., "high", "medium", "low") */
  severity: Scalars['String']['output'];
  /** Source of the risk information */
  source?: Maybe<Scalars['String']['output']>;
  /** When the risk was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

export type EntityRiskConnection = {
  __typename?: 'EntityRiskConnection';
  edges: Array<EntityRiskEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EntityRiskEdge = {
  __typename?: 'EntityRiskEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: EntityRisk;
};

export type EventFingerprint = {
  __typename?: 'EventFingerprint';
  eventHash: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  signatureText: Scalars['String']['output'];
};

export type EventFingerprintConnection = {
  __typename?: 'EventFingerprintConnection';
  edges: Array<EventFingerprintEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EventFingerprintEdge = {
  __typename?: 'EventFingerprintEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: EventFingerprint;
};

/** Input type for filtering */
export type FilterInput = {
  /** Field name to filter on (must match model's filterable fields) */
  field: Scalars['String']['input'];
  /** Filter operation to apply */
  operation: FilterOperation;
  /**
   * Value to filter by (required for all operations except IsNull/IsNotNull).
   * For InList/NotInList operations, this should be the list UUID as a string.
   */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FilterNode = {
  __typename?: 'FilterNode';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  inputs: Array<WorkflowNodeSlot>;
  label?: Maybe<Scalars['String']['output']>;
  outputs: Array<WorkflowNodeSlot>;
  position: Scalars['JSON']['output'];
  styleData: Scalars['JSON']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Filter operations supported by the pagination system */
export enum FilterOperation {
  /** Equal to */
  Eq = 'EQ',
  /** Greater than */
  Gt = 'GT',
  /** Greater than or equal to */
  Gte = 'GTE',
  /**
   * Value exists in a list (value should be the list UUID)
   * Only valid for address fields (from, to)
   */
  InList = 'IN_LIST',
  /** Value is NOT NULL */
  IsNotNull = 'IS_NOT_NULL',
  /** Value is NULL */
  IsNull = 'IS_NULL',
  /** SQL ILIKE pattern matching (case-insensitive) */
  ILike = 'I_LIKE',
  /** SQL LIKE pattern matching */
  Like = 'LIKE',
  /** Less than */
  Lt = 'LT',
  /** Less than or equal to */
  Lte = 'LTE',
  /** Not equal to */
  NotEq = 'NOT_EQ',
  /**
   * Value does NOT exist in a list (value should be the list UUID)
   * Only valid for address fields (from, to)
   */
  NotInList = 'NOT_IN_LIST',
}

export type Fingerprint =
  | BlockFingerprint
  | LogFingerprint
  | TransactionFingerprint;

/** Result of matching a single fingerprint field against fetched data */
export type FingerprintMatchResult = {
  __typename?: 'FingerprintMatchResult';
  /** The actual value from the fetched blockchain data */
  actual: Scalars['String']['output'];
  /** The expected value from the fingerprint definition */
  expected: Scalars['String']['output'];
  /** The name of the fingerprint field (e.g., "from", "to", "value") */
  field: Scalars['String']['output'];
  /** Whether the values matched */
  matched: Scalars['Boolean']['output'];
};

export type FingerprintValue = {
  __typename?: 'FingerprintValue';
  value: Scalars['JSON']['output'];
  valueType: FingerprintValueType;
};

export enum FingerprintValueType {
  Boolean = 'BOOLEAN',
  Hash = 'HASH',
  /** Represents a list reference (stores UUID of the list) */
  List = 'LIST',
  MonetaryValue = 'MONETARY_VALUE',
  Null = 'NULL',
  Number = 'NUMBER',
  String = 'STRING',
}

/** Input for generating a signal from natural language */
export type GenerateSignalInput = {
  /** Natural language description of what the signal should monitor */
  description: Scalars['String']['input'];
};

/** A fingerprint generated by AI (generic format before type-specific conversion) */
export type GeneratedFingerprint = {
  __typename?: 'GeneratedFingerprint';
  /** The field to match on (e.g., "From", "To", "Address", "Topic0") */
  field: Scalars['String']['output'];
  /** The comparison operator */
  operator: ConditionOperator;
  /** The value to compare against (JSON format) */
  value: Scalars['JSON']['output'];
};

/**
 * Result from AI signal generation
 * Contains the generated signal configuration plus AI metadata
 */
export type GeneratedSignalResult = {
  __typename?: 'GeneratedSignalResult';
  /** AI confidence score (0.0 - 1.0) */
  confidence: Scalars['Float']['output'];
  /** Description of what the signal monitors */
  description: Scalars['String']['output'];
  /** The fingerprint conditions */
  fingerprints: Array<GeneratedFingerprint>;
  /** Suggested name for the signal */
  name: Scalars['String']['output'];
  /** AI's reasoning for the generated configuration */
  reasoning: Scalars['String']['output'];
  /** The type of signal (Transaction, Log, or Block) */
  signalType: SignalType;
};

/** Input for importing an ABI */
export type ImportAbiInput = {
  abiJson: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** Payload for import ABI mutation */
export type ImportAbiPayload = {
  __typename?: 'ImportAbiPayload';
  abi: ContractAbi;
};

/** Input for importing contract source code */
export type ImportContractSourceInput = {
  /** Chain ID */
  chainId: Scalars['Int']['input'];
  /** Compiler version (e.g., "0.8.20") */
  compilerVersion: Scalars['String']['input'];
  /** ABI-encoded constructor arguments */
  constructorArguments?: InputMaybe<Scalars['String']['input']>;
  /** Contract address */
  contractAddress: Scalars['String']['input'];
  /** Name of the main contract in the source file */
  contractName?: InputMaybe<Scalars['String']['input']>;
  /** EVM version (e.g., "paris", "shanghai") */
  evmVersion?: InputMaybe<Scalars['String']['input']>;
  /** Whether optimization was enabled */
  optimizationEnabled: Scalars['Boolean']['input'];
  /** Number of optimization runs (if optimization was enabled) */
  optimizationRuns?: InputMaybe<Scalars['Int']['input']>;
  /** Solidity source code */
  sourceCode: Scalars['String']['input'];
};

/** Payload for import contract source mutation */
export type ImportContractSourcePayload = {
  __typename?: 'ImportContractSourcePayload';
  /** The imported contract source */
  source: ContractSource;
};

export type List = {
  __typename?: 'List';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isSystem: Scalars['Boolean']['output'];
  itemType: ListItemType;
  /** Items in this list (addresses, strings, or bytes32 values) */
  items: ListItemConnection;
  name: Scalars['String']['output'];
  owner?: Maybe<Owner>;
  status: ListStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type ListItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<FilterInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortInput>;
};

export type ListConnection = {
  __typename?: 'ListConnection';
  edges: Array<ListEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ListEdge = {
  __typename?: 'ListEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: List;
};

export type ListItem = {
  __typename?: 'ListItem';
  /** When this item was added to the list */
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  /** Optional metadata associated with this item */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** The typed value - returns Address based on parent list's item_type */
  value: ListItemValue;
};

export type ListItemConnection = {
  __typename?: 'ListItemConnection';
  edges: Array<ListItemEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ListItemEdge = {
  __typename?: 'ListItemEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ListItem;
};

export enum ListItemType {
  Address = 'ADDRESS',
}

/**
 * Union type for list item values based on the list's item_type
 * Currently only supports Address, but can be extended for String and Bytes32
 */
export type ListItemValue = Address;

export enum ListStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
}

export type Log = {
  __typename?: 'Log';
  /** Contract address that emitted this log */
  address: Address;
  /** Block hash containing this log */
  blockHash: Scalars['String']['output'];
  /** Block number containing this log */
  blockNumber: Scalars['Int']['output'];
  /** Timestamp when this log record was created */
  createdAt: Scalars['DateTime']['output'];
  /** Log data (hex-encoded) */
  data: Scalars['String']['output'];
  /** Unique ID of the log */
  id: Scalars['UUID']['output'];
  /** Index of this log within the transaction */
  logIndex: Scalars['Int']['output'];
  /** Whether this log was removed (due to chain reorganization) */
  removed: Scalars['Boolean']['output'];
  /** First topic (typically event signature hash) */
  topic0?: Maybe<Scalars['String']['output']>;
  /** Second topic (typically first indexed parameter) */
  topic1?: Maybe<Scalars['String']['output']>;
  /** Third topic (typically second indexed parameter) */
  topic2?: Maybe<Scalars['String']['output']>;
  /** Fourth topic (typically third indexed parameter) */
  topic3?: Maybe<Scalars['String']['output']>;
  /** Transaction hash that emitted this log */
  transactionHash: Scalars['String']['output'];
  /** Index of the transaction in the block */
  transactionIndex: Scalars['Int']['output'];
};

export enum LogField {
  Address = 'ADDRESS',
  BlockHash = 'BLOCK_HASH',
  BlockNumber = 'BLOCK_NUMBER',
  Data = 'DATA',
  LogIndex = 'LOG_INDEX',
  Topic_0 = 'TOPIC_0',
  Topic_1 = 'TOPIC_1',
  Topic_2 = 'TOPIC_2',
  Topic_3 = 'TOPIC_3',
  TransactionHash = 'TRANSACTION_HASH',
  TransactionIndex = 'TRANSACTION_INDEX',
}

export type LogFingerprint = {
  __typename?: 'LogFingerprint';
  field: LogField;
  operation: ConditionOperator;
  value: FingerprintValue;
};

/** Input for testing a Log signal */
export type LogTestInput = {
  /** The log index within the transaction */
  logIndex: Scalars['Int']['input'];
  /** The transaction hash containing the log (0x-prefixed hex string) */
  txHash: Scalars['String']['input'];
};

export type MergeNode = {
  __typename?: 'MergeNode';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  inputs: Array<WorkflowNodeSlot>;
  label?: Maybe<Scalars['String']['output']>;
  outputs: Array<WorkflowNodeSlot>;
  position: Scalars['JSON']['output'];
  styleData: Scalars['JSON']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Create a new alert with optional inline destinations */
  createAlert: Alert;
  /**
   * Create a new API key (user or team)
   * TODO: check billing for API key quotas/limits per user/team
   */
  createApiKey: CreateApiKeyPayload;
  createDiscordBot: DiscordBot;
  createDiscordBotChannel: DiscordBotChannel;
  createDiscordMessage: DiscordMessage;
  /** Create a new Discord server integration */
  createDiscordServer: DiscordServer;
  /** Create a new entity */
  createEntity: Entity;
  /** Create a new address list with optional inline addresses */
  createList: List;
  /** Create a list item (add an address/string/bytes32 to a list) */
  createListItem: ListItem;
  createSignal: Signal;
  createSlackMessage: SlackMessage;
  /** Create a new team (creator becomes owner) */
  createTeam: Team;
  /**
   * Create a new user
   * TODO: send onboarding email
   */
  createUser: User;
  /** Create a new webhook integration */
  createWebhook: Webhook;
  createWorkflow: Workflow;
  createWorkflowEdge: WorkflowGraphEdge;
  createWorkflowNode: WorkflowNode;
  createWorkflowNodeSlot: WorkflowNodeSlot;
  /** Delete an alert */
  deleteAlert: Scalars['Boolean']['output'];
  deleteDiscordBot: Scalars['Boolean']['output'];
  deleteDiscordBotChannel: Scalars['Boolean']['output'];
  /** Delete a Discord server integration */
  deleteDiscordServer: Scalars['Boolean']['output'];
  /** Delete a list */
  deleteList: Scalars['Boolean']['output'];
  /** Delete a list item (remove an address/string/bytes32 from a list) */
  deleteListItem: Scalars['Boolean']['output'];
  /** Delete a signal and its associated fingerprints */
  deleteSignal: Scalars['Boolean']['output'];
  /** Delete a Slack installation */
  deleteSlackInstallation: Scalars['Boolean']['output'];
  /** Delete a team (owner only; enforce safe deletion semantics) */
  deleteTeam: Scalars['Boolean']['output'];
  /** Delete a user (admin/owner only; forbid deleting sole owner without transfer) */
  deleteUser: Scalars['Boolean']['output'];
  /** Delete a webhook integration */
  deleteWebhook: Scalars['Boolean']['output'];
  /**
   * Generate a signal configuration from a natural language description using AI.
   * Returns a signal configuration for user review without persisting to the database.
   * Requires ANTHROPIC_API_KEY environment variable to be set.
   */
  generateSignal: GeneratedSignalResult;
  /** Import a contract ABI */
  importAbi: ImportAbiPayload;
  /** Import contract source code */
  importContractSource: ImportContractSourcePayload;
  /** Revoke (delete) an API key */
  revokeApiKey: Scalars['Boolean']['output'];
  /** Set the active team for the current user (must be a member) */
  setActiveTeam: User;
  /** Test a Discord bot token before creating the bot */
  testDiscordBotToken: TestIntegrationResult;
  /** Test a Discord server connection */
  testDiscordServer: TestIntegrationResult;
  /** Test a signal configuration by validating its fingerprints */
  testSignal: TestIntegrationResult;
  /**
   * Test a signal against real blockchain data
   *
   * This mutation fetches real blockchain data via RPC and tests the signal's
   * fingerprints against it. The input type must match the signal's type:
   * - Transaction signals require `transaction` input with a tx hash
   * - Block signals require `block` input with block number or hash
   * - Log signals require `log` input with tx hash and log index
   */
  testSignalWithData: TestSignalResult;
  /** Test a Slack installation connection */
  testSlackInstallation: TestIntegrationResult;
  /** Test a webhook connection */
  testWebhook: TestIntegrationResult;
  /** Test a webhook configuration before creating it */
  testWebhookConfig: TestIntegrationResult;
  /** Transfer team ownership to another user (owner only) */
  transferTeamOwnership: Team;
  /** Update an existing alert */
  updateAlert: Alert;
  updateDiscordBot: DiscordBot;
  updateDiscordBotChannel: DiscordBotChannel;
  updateDiscordMessage: DiscordMessage;
  /** Update an existing Discord server integration */
  updateDiscordServer: DiscordServer;
  /** Update an existing list */
  updateList: List;
  updateSlackMessage: SlackMessage;
  /** Update a team (admin/owner only) */
  updateTeam: Team;
  /** Update a user (self or same-team + admin/owner where permitted) */
  updateUser: User;
  /** Update an existing webhook integration */
  updateWebhook: Webhook;
};

export type MutationCreateAlertArgs = {
  input: CreateAlertInput;
};

export type MutationCreateApiKeyArgs = {
  input: CreateApiKeyInput;
};

export type MutationCreateDiscordBotArgs = {
  input: CreateDiscordBotInput;
};

export type MutationCreateDiscordBotChannelArgs = {
  input: CreateDiscordBotChannelInput;
};

export type MutationCreateDiscordMessageArgs = {
  input: CreateDiscordMessageInput;
};

export type MutationCreateDiscordServerArgs = {
  input: CreateDiscordServerInput;
};

export type MutationCreateEntityArgs = {
  input: CreateEntityInput;
};

export type MutationCreateListArgs = {
  input: CreateListInput;
};

export type MutationCreateListItemArgs = {
  input: CreateListItemInput;
};

export type MutationCreateSignalArgs = {
  input: CreateSignalInput;
};

export type MutationCreateSlackMessageArgs = {
  input: CreateSlackMessageInput;
};

export type MutationCreateTeamArgs = {
  input: CreateTeamInput;
};

export type MutationCreateUserArgs = {
  input: CreateUserInput;
};

export type MutationCreateWebhookArgs = {
  input: CreateWebhookInput;
};

export type MutationCreateWorkflowArgs = {
  input: CreateWorkflowInput;
};

export type MutationCreateWorkflowEdgeArgs = {
  input: CreateWorkflowEdgeInput;
};

export type MutationCreateWorkflowNodeArgs = {
  input: CreateWorkflowNodeInput;
};

export type MutationCreateWorkflowNodeSlotArgs = {
  input: CreateWorkflowNodeSlotInput;
};

export type MutationDeleteAlertArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationDeleteDiscordBotArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationDeleteDiscordBotChannelArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationDeleteDiscordServerArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationDeleteListArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationDeleteListItemArgs = {
  input: DeleteListItemInput;
};

export type MutationDeleteSignalArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationDeleteSlackInstallationArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationDeleteTeamArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationDeleteUserArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationDeleteWebhookArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationGenerateSignalArgs = {
  input: GenerateSignalInput;
};

export type MutationImportAbiArgs = {
  input: ImportAbiInput;
};

export type MutationImportContractSourceArgs = {
  input: ImportContractSourceInput;
};

export type MutationRevokeApiKeyArgs = {
  keyId: Scalars['UUID']['input'];
};

export type MutationSetActiveTeamArgs = {
  teamId: Scalars['UUID']['input'];
};

export type MutationTestDiscordBotTokenArgs = {
  botToken: Scalars['String']['input'];
};

export type MutationTestDiscordServerArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationTestSignalArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationTestSignalWithDataArgs = {
  input: TestSignalInput;
  signalId: Scalars['UUID']['input'];
};

export type MutationTestSlackInstallationArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationTestWebhookArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationTestWebhookConfigArgs = {
  method: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type MutationTransferTeamOwnershipArgs = {
  newOwnerUserId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
};

export type MutationUpdateAlertArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateAlertInput;
};

export type MutationUpdateDiscordBotArgs = {
  input: UpdateDiscordBotInput;
};

export type MutationUpdateDiscordBotChannelArgs = {
  input: UpdateDiscordBotChannelInput;
};

export type MutationUpdateDiscordMessageArgs = {
  input: UpdateDiscordMessageInput;
};

export type MutationUpdateDiscordServerArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateDiscordServerInput;
};

export type MutationUpdateListArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateListInput;
};

export type MutationUpdateSlackMessageArgs = {
  input: UpdateSlackMessageInput;
};

export type MutationUpdateTeamArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateTeamInput;
};

export type MutationUpdateUserArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateUserInput;
};

export type MutationUpdateWebhookArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateWebhookInput;
};

/** Union type representing ownership - can be either a User or a Team */
export type Owner = Team | User;

/** Information about pagination in a connection */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  /** Get an address with its associated instrumentation data (lists, alerts, workflows) */
  address: Address;
  /** Get a specific alert by ID */
  alert?: Maybe<Alert>;
  /** Get alerts owned by a user or team */
  alerts: AlertConnection;
  block?: Maybe<Block>;
  blocks: BlockConnection;
  /** Get contract by address and chain ID */
  contract?: Maybe<Contract>;
  /** List contracts with optional filters */
  contracts: ContractConnection;
  /** Get decoded blockchain events with pagination */
  decodedEvents: DecodedEventConnection;
  discordBot?: Maybe<DiscordBot>;
  discordBots: Array<DiscordBot>;
  discordServer?: Maybe<DiscordServer>;
  discordServers: DiscordServerConnection;
  /** Get all entities (e.g., OFAC SDN entities) */
  entities: EntityConnection;
  /** Get a specific entity by ID */
  entity?: Maybe<Entity>;
  eventFingerprints: EventFingerprintConnection;
  /** Get a specific list by ID */
  list?: Maybe<List>;
  /** Get lists owned by a user or team */
  lists: ListConnection;
  /** Get the currently authenticated user */
  me: User;
  /** Get all API keys owned by the current user (no secrets) */
  myApiKeys: Array<ApiKey>;
  /** Get all teams the current user belongs to */
  myTeams: Array<Team>;
  /** Get a specific signal by ID */
  signal?: Maybe<Signal>;
  /** Get all signals */
  signals: SignalConnection;
  slackChannel?: Maybe<SlackChannel>;
  slackChannels: SlackChannelConnection;
  slackInstallation?: Maybe<SlackInstallation>;
  slackInstallations: SlackInstallationConnection;
  slackMessage?: Maybe<SlackMessage>;
  slackMessages: SlackMessageConnection;
  /** Get a specific team by ID (must be a member) */
  team?: Maybe<Team>;
  /** Get all API keys for a specific team (admin/owner only, no secrets) */
  teamApiKeys: Array<ApiKey>;
  /** Get events for all users in a team (admin/owner only) */
  teamEvents: UserEventConnection;
  /** Get all users in a team (admin/owner only) */
  teamUsers: Array<User>;
  transaction?: Maybe<Transaction>;
  transactions: TransactionConnection;
  /** Get a specific user by ID (self or same-team + admin/owner) */
  user?: Maybe<User>;
  /** Get events for the current user (own events) */
  userEvents: UserEventConnection;
  webhook?: Maybe<Webhook>;
  webhooks: WebhookConnection;
  workflow?: Maybe<Workflow>;
  workflowNode?: Maybe<WorkflowNode>;
  workflows: WorkflowConnection;
};

export type QueryAddressArgs = {
  address: Scalars['String']['input'];
};

export type QueryAlertArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryAlertsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ownerTeamId?: InputMaybe<Scalars['UUID']['input']>;
  ownerUserId?: InputMaybe<Scalars['UUID']['input']>;
  signalId?: InputMaybe<Scalars['UUID']['input']>;
};

export type QueryBlockArgs = {
  chainId?: Scalars['Int']['input'];
  number: Scalars['Int']['input'];
};

export type QueryBlocksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<FilterInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortInput>;
};

export type QueryContractArgs = {
  address: Scalars['String']['input'];
  chainId: Scalars['Int']['input'];
};

export type QueryContractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chainId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryDecodedEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  eventName?: InputMaybe<Scalars['String']['input']>;
  eventSignature?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryDiscordBotArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryDiscordBotsArgs = {
  discordGuildId?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  ownerTeamId?: InputMaybe<Scalars['UUID']['input']>;
  ownerUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type QueryDiscordServerArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryDiscordServersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ownerTeamId?: InputMaybe<Scalars['UUID']['input']>;
  ownerUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type QueryEntitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<FilterInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortInput>;
};

export type QueryEntityArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryEventFingerprintsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<FilterInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortInput>;
};

export type QueryListArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ownerTeamId?: InputMaybe<Scalars['UUID']['input']>;
  ownerUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type QuerySignalArgs = {
  id: Scalars['UUID']['input'];
};

export type QuerySignalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerySlackChannelArgs = {
  id: Scalars['UUID']['input'];
};

export type QuerySlackChannelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channelType?: InputMaybe<SlackChannelType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  installationId: Scalars['UUID']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerySlackInstallationArgs = {
  id: Scalars['UUID']['input'];
};

export type QuerySlackInstallationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ownerTeamId?: InputMaybe<Scalars['UUID']['input']>;
  ownerUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type QuerySlackMessageArgs = {
  id: Scalars['UUID']['input'];
};

export type QuerySlackMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasBlocks?: InputMaybe<Scalars['Boolean']['input']>;
  installationId?: InputMaybe<Scalars['UUID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryTeamArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryTeamApiKeysArgs = {
  teamId: Scalars['UUID']['input'];
};

export type QueryTeamEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<FilterInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortInput>;
  teamId: Scalars['UUID']['input'];
};

export type QueryTeamUsersArgs = {
  teamId: Scalars['UUID']['input'];
};

export type QueryTransactionArgs = {
  hash: Scalars['String']['input'];
};

export type QueryTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<FilterInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortInput>;
};

export type QueryUserArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryUserEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<FilterInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortInput>;
};

export type QueryWebhookArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryWebhooksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ownerTeamId?: InputMaybe<Scalars['UUID']['input']>;
  ownerUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type QueryWorkflowArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryWorkflowNodeArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryWorkflowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<FilterInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortInput>;
};

export enum RunStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Running = 'RUNNING',
}

export type Signal = {
  __typename?: 'Signal';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  fingerprints: Array<Fingerprint>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  signalType: SignalType;
  /**
   * Paginated triggers for this signal.
   * Supports filtering, sorting, and standard Relay pagination.
   * Default sort: triggeredAt DESC
   */
  triggers: SignalTriggerConnection;
  updatedAt: Scalars['DateTime']['output'];
};

export type SignalTriggersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<FilterInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortInput>;
};

export type SignalConnection = {
  __typename?: 'SignalConnection';
  edges: Array<SignalEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SignalEdge = {
  __typename?: 'SignalEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Signal;
};

export type SignalNode = {
  __typename?: 'SignalNode';
  /** Get control flow slots (execution flow connections) */
  controlFlows: Array<WorkflowNodeSlot>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  outputs: Array<WorkflowNodeSlot>;
  position: Scalars['JSON']['output'];
  signal: Signal;
  styleData: Scalars['JSON']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SignalTrigger = {
  __typename?: 'SignalTrigger';
  /** The block containing the transaction that triggered this signal. */
  block?: Maybe<Block>;
  chainId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  matchDetails?: Maybe<Scalars['JSON']['output']>;
  signal: Signal;
  /** The transaction that triggered this signal match. */
  transaction?: Maybe<Transaction>;
  triggeredAt: Scalars['DateTime']['output'];
};

export type SignalTriggerConnection = {
  __typename?: 'SignalTriggerConnection';
  edges: Array<SignalTriggerEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SignalTriggerEdge = {
  __typename?: 'SignalTriggerEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: SignalTrigger;
};

export enum SignalType {
  Block = 'BLOCK',
  Log = 'LOG',
  Network = 'NETWORK',
  Transaction = 'TRANSACTION',
}

export type SlackChannel = {
  __typename?: 'SlackChannel';
  channelType: SlackChannelType;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  installationId: Scalars['UUID']['output'];
  isArchived: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  slackChannelId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SlackChannelConnection = {
  __typename?: 'SlackChannelConnection';
  edges: Array<SlackChannelEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SlackChannelEdge = {
  __typename?: 'SlackChannelEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: SlackChannel;
};

export enum SlackChannelType {
  Im = 'IM',
  Mpim = 'MPIM',
  PrivateChannel = 'PRIVATE_CHANNEL',
  PublicChannel = 'PUBLIC_CHANNEL',
}

export type SlackInstallation = {
  __typename?: 'SlackInstallation';
  botUserId: Scalars['String']['output'];
  botUserName?: Maybe<Scalars['String']['output']>;
  connectionStatus: ConnectionStatus;
  createdAt: Scalars['DateTime']['output'];
  enterpriseId?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  ownerTeamId?: Maybe<Scalars['UUID']['output']>;
  ownerUserId?: Maybe<Scalars['UUID']['output']>;
  slackTeamId: Scalars['String']['output'];
  teamDomain?: Maybe<Scalars['String']['output']>;
  tokenLastRotatedAt?: Maybe<Scalars['DateTime']['output']>;
  tokenScopes?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SlackInstallationConnection = {
  __typename?: 'SlackInstallationConnection';
  edges: Array<SlackInstallationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SlackInstallationEdge = {
  __typename?: 'SlackInstallationEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: SlackInstallation;
};

export type SlackMessage = {
  __typename?: 'SlackMessage';
  blocks?: Maybe<Scalars['JSON']['output']>;
  channel?: Maybe<SlackChannel>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  installation?: Maybe<SlackInstallation>;
  lastError?: Maybe<Scalars['String']['output']>;
  lastSentTs?: Maybe<Scalars['String']['output']>;
  metadata: Scalars['JSON']['output'];
  text?: Maybe<Scalars['String']['output']>;
  threadTs?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SlackMessageAction = {
  __typename?: 'SlackMessageAction';
  actionType: ActionType;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  slackMessage: SlackMessage;
  updatedAt: Scalars['DateTime']['output'];
};

export type SlackMessageConnection = {
  __typename?: 'SlackMessageConnection';
  edges: Array<SlackMessageEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SlackMessageEdge = {
  __typename?: 'SlackMessageEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: SlackMessage;
};

export enum SlotDataType {
  Address = 'ADDRESS',
  Array = 'ARRAY',
  Bytes = 'BYTES',
  Number = 'NUMBER',
  Object = 'OBJECT',
  String = 'STRING',
  Topic = 'TOPIC',
}

export enum SlotDirection {
  Input = 'INPUT',
  Output = 'OUTPUT',
}

export enum SlotType {
  Control = 'CONTROL',
  Variable = 'VARIABLE',
}

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

/** Input type for sorting */
export type SortInput = {
  /** Sort direction */
  direction: SortDirection;
  /** Field name to sort by (must match model's OrderField) */
  field: Scalars['String']['input'];
  /** Optional relationship to join for sorting (e.g., "entity" to sort by entity.name) */
  rel?: InputMaybe<Scalars['String']['input']>;
};

export type SubWorkflowNode = {
  __typename?: 'SubWorkflowNode';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  inputs: Array<WorkflowNodeSlot>;
  label?: Maybe<Scalars['String']['output']>;
  outputs: Array<WorkflowNodeSlot>;
  position: Scalars['JSON']['output'];
  styleData: Scalars['JSON']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Team = {
  __typename?: 'Team';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  /** Get all members of the team (admin/owner only) */
  members: TeamMemberConnection;
  name: Scalars['String']['output'];
  /** Get the owner of the team */
  owner?: Maybe<User>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TeamMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TeamConnection = {
  __typename?: 'TeamConnection';
  edges: Array<TeamEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TeamEdge = {
  __typename?: 'TeamEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Team;
};

export type TeamMember = {
  __typename?: 'TeamMember';
  joinedAt: Scalars['DateTime']['output'];
  role: TeamMemberRole;
  user: User;
};

export type TeamMemberConnection = {
  __typename?: 'TeamMemberConnection';
  edges: Array<TeamMemberEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TeamMemberEdge = {
  __typename?: 'TeamMemberEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: TeamMember;
};

export enum TeamMemberRole {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  Owner = 'OWNER',
}

export type TestIntegrationResult = {
  __typename?: 'TestIntegrationResult';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/**
 * Input for testing a signal against real blockchain data.
 * The input variant must match the signal's type.
 */
export type TestSignalInput = {
  /** Test a Block signal with a block number or hash */
  block?: InputMaybe<BlockTestInput>;
  /** Test a Log signal with a transaction hash and log index */
  log?: InputMaybe<LogTestInput>;
  /** Test a Transaction signal with a transaction hash */
  transaction?: InputMaybe<TransactionTestInput>;
};

/** Result of testing a signal against real blockchain data */
export type TestSignalResult = {
  __typename?: 'TestSignalResult';
  /** Error message if the test failed (RPC error, invalid input, etc.) */
  error?: Maybe<Scalars['String']['output']>;
  /** Summary of the fetched blockchain data */
  fetchedDataSummary?: Maybe<Scalars['String']['output']>;
  /** Per-fingerprint match results */
  fingerprintResults: Array<FingerprintMatchResult>;
  /** Whether all fingerprints matched the fetched data */
  overallMatch: Scalars['Boolean']['output'];
};

export type Transaction = {
  __typename?: 'Transaction';
  blockHash?: Maybe<Scalars['String']['output']>;
  blockNumber?: Maybe<Scalars['Int']['output']>;
  chainId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentValueUsd?: Maybe<Scalars['Decimal']['output']>;
  from: Address;
  gas: Scalars['Int']['output'];
  gasPrice?: Maybe<Scalars['Decimal']['output']>;
  hash: Scalars['String']['output'];
  input: Scalars['String']['output'];
  maxFeePerBlobGas?: Maybe<Scalars['Decimal']['output']>;
  maxFeePerGas?: Maybe<Scalars['Decimal']['output']>;
  maxPriorityFeePerGas?: Maybe<Scalars['Decimal']['output']>;
  nonce: Scalars['Int']['output'];
  /**
   * Risks for addresses involved in this transaction (from or to addresses)
   * Returns a paginated connection of address risks with filtering and sorting
   */
  risks: AddressRiskConnection;
  status: TransactionStatus;
  to?: Maybe<Address>;
  transactionIndex?: Maybe<Scalars['Int']['output']>;
  value: Array<Scalars['Int']['output']>;
  valueEth: Scalars['Decimal']['output'];
  valueUsd?: Maybe<Scalars['Decimal']['output']>;
};

export type TransactionRisksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<FilterInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortInput>;
};

export type TransactionConnection = {
  __typename?: 'TransactionConnection';
  edges: Array<TransactionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TransactionEdge = {
  __typename?: 'TransactionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Transaction;
};

export enum TransactionField {
  From = 'FROM',
  Gas = 'GAS',
  GasPrice = 'GAS_PRICE',
  Input = 'INPUT',
  MaxFeePerGas = 'MAX_FEE_PER_GAS',
  MaxPriorityFeePerGas = 'MAX_PRIORITY_FEE_PER_GAS',
  To = 'TO',
  Value = 'VALUE',
}

export type TransactionFingerprint = {
  __typename?: 'TransactionFingerprint';
  field: TransactionField;
  operation: ConditionOperator;
  value: FingerprintValue;
};

export type TransactionFingerprintInput = {
  field: TransactionField;
  operator: ConditionOperator;
  /**
   * The value to compare against.
   * For IN_LIST/NOT_IN_LIST operators, this should be the list UUID as a string.
   */
  value: Scalars['JSON']['input'];
};

export enum TransactionStatus {
  Confirmed = 'CONFIRMED',
  Failed = 'FAILED',
  Pending = 'PENDING',
}

/** Input for testing a Transaction signal */
export type TransactionTestInput = {
  /** The transaction hash to test against (0x-prefixed hex string) */
  txHash: Scalars['String']['input'];
};

export type Transformer = {
  __typename?: 'Transformer';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  inputSchema: Scalars['JSON']['output'];
  name: Scalars['String']['output'];
  outputSchema: Scalars['JSON']['output'];
  transformationLogic: Scalars['JSON']['output'];
  transformerType: TransformerType;
  updatedAt: Scalars['DateTime']['output'];
};

export type TransformerNode = {
  __typename?: 'TransformerNode';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  inputs: Array<WorkflowNodeSlot>;
  label?: Maybe<Scalars['String']['output']>;
  outputs: Array<WorkflowNodeSlot>;
  position: Scalars['JSON']['output'];
  styleData: Scalars['JSON']['output'];
  transformer: Transformer;
  updatedAt: Scalars['DateTime']['output'];
};

export enum TransformerType {
  AbiDecoder = 'ABI_DECODER',
  LlmCall = 'LLM_CALL',
  UnitConverter = 'UNIT_CONVERTER',
}

export type UpdateAlertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional destinations to replace all existing destinations
   * When provided, all existing destinations will be removed and replaced with these
   */
  destinations?: InputMaybe<Array<CreateAlertDestinationInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AlertStatus>;
};

export type UpdateDiscordBotChannelInput = {
  id: Scalars['UUID']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDiscordBotInput = {
  applicationId?: InputMaybe<Scalars['String']['input']>;
  botToken?: InputMaybe<Scalars['String']['input']>;
  botUserId?: InputMaybe<Scalars['String']['input']>;
  botUsername?: InputMaybe<Scalars['String']['input']>;
  discordGuildId?: InputMaybe<Scalars['String']['input']>;
  guildName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  publicKey?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDiscordMessageInput = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  embeds?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['UUID']['input'];
  tts?: InputMaybe<Scalars['Boolean']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDiscordServerInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateListInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ListStatus>;
};

export type UpdateSlackMessageInput = {
  blocks?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['UUID']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
  threadTs?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTeamInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWebhookInput = {
  headers?: InputMaybe<Scalars['JSON']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  method?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  /** Get the user's currently active team */
  activeTeam?: Maybe<Team>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Get all teams the user belongs to */
  teams: TeamConnection;
  updatedAt: Scalars['DateTime']['output'];
};

export type UserTeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type UserEvent = {
  __typename?: 'UserEvent';
  createdAt: Scalars['DateTime']['output'];
  eventType: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  metadata: Scalars['JSON']['output'];
  userId: Scalars['UUID']['output'];
};

export type UserEventConnection = {
  __typename?: 'UserEventConnection';
  edges: Array<UserEventEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserEventEdge = {
  __typename?: 'UserEventEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UserEvent;
};

export type ViewportState = {
  __typename?: 'ViewportState';
  x: Scalars['Int']['output'];
  y: Scalars['Int']['output'];
  zoom: Scalars['Int']['output'];
};

export type ViewportStateInput = {
  x: Scalars['Int']['input'];
  y: Scalars['Int']['input'];
  zoom: Scalars['Int']['input'];
};

export type Webhook = {
  __typename?: 'Webhook';
  connectionStatus: ConnectionStatus;
  createdAt: Scalars['DateTime']['output'];
  headers?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['UUID']['output'];
  label: Scalars['String']['output'];
  method: Scalars['String']['output'];
  ownerTeamId?: Maybe<Scalars['UUID']['output']>;
  ownerUserId?: Maybe<Scalars['UUID']['output']>;
  type: WebhookType;
  url: Scalars['String']['output'];
};

export type WebhookAction = {
  __typename?: 'WebhookAction';
  actionType: ActionType;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  webhookAction?: Maybe<Scalars['JSON']['output']>;
};

export type WebhookConnection = {
  __typename?: 'WebhookConnection';
  edges: Array<WebhookEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WebhookEdge = {
  __typename?: 'WebhookEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Webhook;
};

export enum WebhookType {
  Discord = 'DISCORD',
  Http = 'HTTP',
  Slack = 'SLACK',
}

export type Workflow = {
  __typename?: 'Workflow';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  graphEdges: WorkflowEdgeConnection;
  graphNodes: WorkflowNodeConnection;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  runs: WorkflowRunConnection;
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['Int']['output'];
  viewportState: ViewportState;
};

export type WorkflowGraphEdgesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkflowGraphNodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkflowRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkflowConnection = {
  __typename?: 'WorkflowConnection';
  edges: Array<WorkflowEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WorkflowEdge = {
  __typename?: 'WorkflowEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Workflow;
};

export type WorkflowEdgeConnection = {
  __typename?: 'WorkflowEdgeConnection';
  edges: Array<WorkflowGraphEdgeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type WorkflowGraphEdge = {
  __typename?: 'WorkflowGraphEdge';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  sourceHandle?: Maybe<Scalars['String']['output']>;
  sourceId: Scalars['UUID']['output'];
  targetHandle?: Maybe<Scalars['String']['output']>;
  targetId: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** An edge in a connection. */
export type WorkflowGraphEdgeEdge = {
  __typename?: 'WorkflowGraphEdgeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: WorkflowGraphEdge;
};

export type WorkflowNode =
  | ActionNode
  | DelayNode
  | EnricherNode
  | FilterNode
  | MergeNode
  | SignalNode
  | SubWorkflowNode
  | TransformerNode;

export type WorkflowNodeConnection = {
  __typename?: 'WorkflowNodeConnection';
  edges: Array<WorkflowNodeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WorkflowNodeEdge = {
  __typename?: 'WorkflowNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: WorkflowNode;
};

export type WorkflowNodeSlot = {
  __typename?: 'WorkflowNodeSlot';
  createdAt: Scalars['DateTime']['output'];
  dataType?: Maybe<SlotDataType>;
  direction: SlotDirection;
  id: Scalars['UUID']['output'];
  key: Scalars['String']['output'];
  nodeId: Scalars['UUID']['output'];
  optional: Scalars['Boolean']['output'];
  slotType: SlotType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum WorkflowNodeType {
  Action = 'ACTION',
  Delay = 'DELAY',
  Enricher = 'ENRICHER',
  Filter = 'FILTER',
  Merge = 'MERGE',
  Signal = 'SIGNAL',
  Transformer = 'TRANSFORMER',
  Workflow = 'WORKFLOW',
}

export type WorkflowRun = {
  __typename?: 'WorkflowRun';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: RunStatus;
  triggerData: Scalars['JSON']['output'];
  workflow?: Maybe<Workflow>;
};

export type WorkflowRunConnection = {
  __typename?: 'WorkflowRunConnection';
  edges: Array<WorkflowRunEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WorkflowRunEdge = {
  __typename?: 'WorkflowRunEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: WorkflowRun;
};
